import styled from "styled-components";
import { IProduct } from "../../client/product/useProduct";
import { Heading6 } from "../../components/Typography";
import { COLOR_WHITE } from "../../constants/colors";

type ProductProps = {
  product: IProduct;
  isEven: boolean;
};

const Link = styled.a`
  display: flex;
  flex-direction: column;
  height: 100%;

  &:hover {
    text-decoration: none;
  }
`;

const ImgWrapper = styled.div`
  width: 100%;
  padding-top: 100%;
  position: relative;
  background-color: ${COLOR_WHITE};
  overflow: hidden;
`;

const ImgProduct = styled.img`
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const ProductTitle = styled.div`
  ${Heading6}
  text-align: center;
  color: ${COLOR_WHITE};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 auto auto;
`;

const ProductPrice = styled.div`
  ${Heading6}
  text-align: center;
  color: ${COLOR_WHITE};
`;

function Product(props: ProductProps) {
  const { product, isEven } = props;

  return (
    <Link href={`/product/${product._id}`}>
      <ImgWrapper
        className="mb-3"
        style={{
          clipPath: isEven
            ? "polygon(25% 0, 80% 0%, 100% 0, 100% 75%, 75% 100%, 0 100%, 0% 80%, 0 25%)"
            : "polygon(0 0, 75% 0, 100% 25%, 100% 80%, 100% 100%, 25% 100%, 0 75%, 0% 20%)",
        }}
      >
        <ImgProduct src={product.images[0]} alt={product.name} className="w-100" />
      </ImgWrapper>
      <ProductTitle>{product.name}</ProductTitle>
      <ProductPrice className="mt-2">${product.price.toFixed(2)}</ProductPrice>
    </Link>
  );
}

export default Product;
